export const generateDeviceFingerprint = (): string => {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  if (ctx) {
    ctx.textBaseline = 'top'
    ctx.font = '14px Arial'
    ctx.fillText('Device Fingerprint', 2, 2)
  }

  const canvasData = canvas.toDataURL()

  const fingerprint = {
    userAgent: navigator.userAgent,
    language: navigator.language,
    platform: navigator.platform,
    screenResolution: `${screen.width}x${screen.height}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    canvasFingerprint: canvasData.slice(0, 100),
  }

  const fingerprintString = JSON.stringify(fingerprint)

  let hash = 0
  for (let i = 0; i < fingerprintString.length; i++) {
    const char = fingerprintString.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash
  }

  return `device_${Math.abs(hash).toString(36)}`
}

export const isTrustedDevice = (userId: string): boolean => {
  const trustedDevices = JSON.parse(
    localStorage.getItem('trustedDevices') || '{}',
  )
  const userDevices = trustedDevices[userId] || []
  const currentFingerprint = generateDeviceFingerprint()

  return userDevices.some(
    (device: any) => device.fingerprint === currentFingerprint,
  )
}
